module.exports = __webpack_public_path__ + "img/bttn_helterskelter.43909ae0.png";